"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const nav_frontend_js_utils_1 = require("nav-frontend-js-utils");
const tabCls = (props) => (0, classnames_1.default)("nav-frontend-tabs__tab-inner", props.className, {
    "nav-frontend-tabs__tab-inner--aktiv": props.aktiv,
    "nav-frontend-tabs__tab-inner--interaktiv": !props.aktiv,
    "nav-frontend-tabs__tab-inner--disabled": props.disabled,
});
class Tab extends React.Component {
    getLabel() {
        return (React.createElement("div", { className: "nav-frontend-tabs__tab-label" }, this.props.label || this.props.children));
    }
    render() {
        const { linkCreator = (props) => React.createElement("button", Object.assign({}, props)) } = this.props;
        const domProps = (0, nav_frontend_js_utils_1.omit)(this.props, "label", "aktiv", "disabled", "linkCreator", "children", "linkRef");
        return (React.createElement("li", { className: "nav-frontend-tabs__tab-outer", role: "presentation" }, linkCreator(Object.assign(Object.assign({}, domProps), { className: tabCls(this.props), role: "tab", "aria-selected": this.props.aktiv, children: this.getLabel(), ref: this.props.linkRef }))));
    }
}
exports.default = Tab;
